<template>
  <div class="gov-title">
    <div class="addTitle">
      <div class="titleName">实体服务</div>
    </div>
    <div class="entityServe">
      <div class="gov-title1">
        <div class="gov-title2">
          <div>服务状态</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              v-model="addForm.entityStatus"
              placeholder="请选择"
              ref="zfyzStatusName"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option label="待签约" :value="1"></el-option>
              <el-option label="在用" :value="2"></el-option>
              <el-option label="注销" :value="3"></el-option>
              <el-option label="拒绝服务" :value="4"></el-option>
            </el-select>
          </div>
        </div>
        <div class="gov-title2 right-title-3">
          <div>机构</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              v-model="addForm.entityStation"
              ref="zfyzEntityName"
              placeholder="请选择"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option
                v-for="item in serviceStationList"
                :key="item.selectTreeId"
                :label="item.statName"
                :value="item.selectTreeId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="gov-title1">
        <div class="gov-title2">
          <div>服务人员</div>
          <div class="flexBox">
            <el-select
              class="selectBorder"
              @change="wUpdata"
              v-model="addForm.entityServicePersonId"
              ref="zfyzServeName"
              placeholder="请选择"
              size="mini"
              :disabled="setTitle === '查看'"
            >
              <el-option
                :label="item.personName"
                :value="item.id"
                v-for="(item, index) in personList"
                :key="index"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="gov-title2 right-title-3">
          <div>每月金额</div>
          <div class="flexBox">
            <el-input
              @blur="wUpdata"
              v-model="addForm.yearMoney"
              type="number"
              :min="0"
              size="mini"
              placeholder="请输入"
              disabled
            ></el-input>
          </div>
        </div>
      </div>
      <div class="gov-title1">
        <div class="gov-title2">
          <div>年限</div>
          <div class="flexBox">
            <el-input
              @blur="wUpdata"
              v-model="addForm.yearsLimits"
              type="number"
              :min="0"
              size="mini"
              placeholder="请输入"
              :disabled="setTitle === '查看'"
            ></el-input>
          </div>
        </div>
        <div class="gov-title2 right-title-3">
          <div>服务次数</div>
          <div class="flexBox">
            <el-input
              @blur="wUpdata"
              v-model="addForm.serveNums"
              type="number"
              :min="0"
              size="mini"
              placeholder="请输入"
              :disabled="setTitle === '查看'"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="gov-title1">
        <div class="gov-title2">
          <div>年度总余额</div>
          <div class="flexBox">
            <el-input
              @blur="wUpdata"
              v-model="addForm.yearMoney"
              type="number"
              :min="0"
              size="mini"
              placeholder="请输入"
              :disabled="setTitle === '查看'"
            ></el-input>
          </div>
        </div>
        <div class="gov-title2 right-title-3">
          <div>年度剩余金额</div>
          <div class="flexBox">
            <el-input
              @blur="wUpdata"
              v-model="addForm.remainingYearMoney"
              type="number"
              :min="0"
              size="mini"
              placeholder="请输入"
              :disabled="setTitle === '查看'"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="right-title-6 right-title-3" >
        <div class="rightTitle"><p style="margin-top:-4px"> 服务项目</p></div>
        <div class="right-title-4 rightBox" style="min-height:30px">
          <!-- @change="wUpdata" -->
          <div>
            <el-checkbox-group
              @change="wUpdata"
              v-model="addForm.projectType"
              :disabled="setTitle === '查看'"
            >
              <el-checkbox
                v-for="data in projectList"
                :label="data.id"
                :key="data.id"
              >
                {{ data.label }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div class="right-title-6 right-title-3">
        <div class="rightTitle"><p>备注信息</p></div>
        <div class="right-title-4 rightBox">
          <el-input
              v-model="addForm.serviceRemark"
              type="textarea"
              size="mini"
              placeholder="请输入"
              :disabled="setTitle === '查看'"
            ></el-input>
        </div>
      </div>
    </div>

    <div class="addTitle">
      <div class="titleName">信息服务</div>
    </div>
    <div class="infoServe">
      <el-table
        :data="equipmentList"
        border
        style="width: 100%; margin-top: 20px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="typeName"
          label="设备类型"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="vendorName"
          label="供应商"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="equSerial"
          label="IMEI号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="years"
          label="年限"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="useStatus"
          label="状态"
          align="center"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.useStatus == 1">待签约</span>
            <span v-if="scope.row.useStatus == 2">在用</span>
            <span v-if="scope.row.useStatus == 3">注销</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pages"
        background
        layout="total, prev, pager, next"
        @current-change="handleCurrentChangeOne"
        :total="pageOne.total"
        :current-page.sync="pageOne.pageNo"
        :page-size="10"
      >
      </el-pagination>
    </div>
    <!-- <div class="addTitle">
            <div class="titleName">工单列表</div>
        </div> -->
    <!-- <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%; margin-top: 20px"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="orderNum"
                    label="工单号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="servePersonName"
                    label="服务人员"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    prop="timeStart"
                    label="开始时间"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeEnd"
                    label="结束时间"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="套餐金额"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="balance"
                    label="余额"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
            </el-table>
            <el-pagination
                class="pages"
                background
                layout="total, prev, pager, next"
                @current-change="handleCurrentChange"
                :total="page.total"
                :current-page.sync="page.pageNo"
                :page-size="10"
            >
            </el-pagination>
        </div> -->
  </div>
</template>

<script>
import request from "@/utils/request.js"
export default {
  props: {
    formData: {},

    setTitle: {
      type: String,
      default: "",
    },
    serviceStation:{
      type:[String,Number],
      default:''
    }
  },
  data() {
    return {
      page: { pageNo: 1, pageSize: 10, total: 0 },
      pageOne: { pageNo: 1, pageSize: 10, total: 0 },
      tableData: [],
      equipmentList: [],
      personList: [],
      serviceStationList: [],
      projectList: [],
      data: {},
      addForm: {
        serveNums: "",
        yearMoney:'',
        yearMoney:'',
        yearsLimits: "",
        servePrices: "",
        projectType: [],
        projectTypeDesc: "",
        entityStatus: "",
        entityStatusDesc: "",
        entityStation: "",
        entityStationName: "",
        entityServicePersonId: "",
        entityServicePersonName: "",
        yearMoney: "",
        serviceRemark: ""
      },
    }
  },
  async created() {
    console.log(this.setTitle,'setTitle')
    // await this.getProject()
    await this.getStation()
    // await this.getWorks()
  },
  watch: {
    formData: {
      handler(val) {
        this.addForm =val
        this.getProject().then((res) => {
          this.projectList = res
          if (this.formData.id) {
            if (val.zfAssistance) {
              this.addForm = {
                projectType: val.zfAssistance.projectType
                  ? val.zfAssistance.projectType.split(",")
                  : [],
                projectTypeDesc: val.zfAssistance.projectTypeDesc
                  ? val.zfAssistance.projectTypeDesc
                  : "",
                entityStatus: val.zfAssistance.entityStatus
                  ? Number(val.zfAssistance.entityStatus)
                  : "",
                entityStatusDesc: val.zfAssistance.entityStatusDesc
                  ? val.zfAssistance.entityStatusDesc
                  : "",
                entityStation: val.zfAssistance.entityStation
                  ? Number(val.zfAssistance.entityStation)
                  : "",
                entityStationName: val.zfAssistance.entityStationName
                  ? val.zfAssistance.entityStationName
                  : "",
                entityServicePersonId: val.zfAssistance.entityServicePersonId
                  ? Number(val.zfAssistance.entityServicePersonId)
                  : "",
                entityServicePersonName: val.zfAssistance
                  .entityServicePersonName
                  ? val.zfAssistance.entityServicePersonName
                  : "",
                yearMoney: val.zfAssistance.yearMoney
                  ? val.zfAssistance.yearMoney
                  : "",
                serveNums: val.zfAssistance.serveNums
                  ? val.zfAssistance.serveNums
                  : "",
                   yearMoney: val.zfAssistance.yearMoney
                  ? val.zfAssistance.yearMoney
                  : "",
                   remainingYearMoney: val.zfAssistance.remainingYearMoney
                  ? val.zfAssistance.remainingYearMoney
                  : "",
                yearsLimits: val.zfAssistance.yearsLimits
                  ? val.zfAssistance.yearsLimits
                  : "",
                servePrices: val.zfAssistance.servePrices
                  ? val.zfAssistance.servePrices
                  : "",
                serviceRemark: val.serviceRemark
              }
              this.$forceUpdate()
            } else {
              this.addForm = {
                serveNums: "",
                yearMoney:'',
                remainingYearMoney:'',
                yearsLimits: "",
                servePrices: "",
                projectType: [],
                projectTypeDesc: "",
                entityStatus: "",
                entityStatusDesc: "",
                entityStation: "",
                entityStationName: "",
                entityServicePersonId: "",
                entityServicePersonName: "",
                yearMoney: "",
                serviceRemark: "",
              }
            }
            this.wUpdata()
          }
          if (val.hide) {
            this.addForm = {
              serveNums: "",
              yearMoney:'',
                remainingYearMoney:'',
              yearsLimits: "",
              servePrices: "",
              projectType: [],
              projectTypeDesc: "",
              entityStatus: "",
              entityStatusDesc: "",
              entityStation: "",
              entityStationName: "",
              entityServicePersonId: "",
              entityServicePersonName: "",
              yearMoney: "",
            }
          }
        })
      },
      deep: true,
      immediate: true,
    },
    "addForm.entityStation"(val, oldVal) {
      if (oldVal != "") {
        this.addForm.entityServicePersonId = ""
        this.addForm.entityServicePersonName = ""
      }
    },
    "addForm.serveNums"(val, oldVal) {
      if (oldVal == "") {
        return
      }
      if (val != "") {
        let yearMoney = Number(val) * Number(this.addForm.servePrices)
        this.addForm.yearMoney = yearMoney
      }
    },
  },
  methods: {
    // 机构
    getStation() {
      request({
        url: "/jjyl/admin/serviceStation/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.serviceStationList = []
            return
          }
          this.serviceStationList = []
          this.serviceStationList = res.content.list.map((item) => {
            return {
              selectTreeId: item.id, //id
              statName: item.statName,
            }
          })
        }
      })
    },
    //服务人员
    getPerson(id) {
      console.log(this.addForm,'id1')
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 10000,
          serviceStationId: this.serviceStation
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.personList = []
            return
          }
          this.personList = []
          this.personList = res.content.elderList.list
        }
      })
    },
    getWorks() {
      request({
        url: "/jjyl/servicePgd/plan/info/findPlanPgdList",
        method: "POST",
        data: {
          pageNo: this.page.pageNo,
          pageSize: this.page.pageSize,
          idCard: this.formData.idCard,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (!res.content) {
            this.tableData = []
            this.page.total = 0
          } else {
            this.tableData = res.content.list || []
            this.page.total = res.content.count || 0
          }
        }
      })
    },
    // 服务项目
    getProject() {
      console.log(this.addForm,'id')
      return new Promise((resolve, reject) => {
        request({
          url: "/jjyl/admin/product/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
            status: 1,
            serviceStation:this.serviceStation
          //  customerId:this.addForm.
          },
        }).then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              resolve([])
            } else {
              let projectList = res.content.list.map((item) => {
                return {
                  id: String(item.id), //id
                  label: item.serviceProductName,
                  price: item.servePrice,
                }
              })
              resolve(projectList)
            }
          }
        })
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.page.pageNo = val
      // this.getWorks()
    },
    handleCurrentChangeOne() {
      this.pageOne.pageNo = val
    },
    wUpdata() {
      // this.addForm.projectTypeDesc = this.$refs.zfyzTypeName.selectedLabel
      // this.addForm.entityStatusDesc =
      //     this.$refs.zfyzStatusName.selectedLabel
      this.addForm.entityStationName = this.$refs.zfyzEntityName.selectedLabel

      this.addForm.entityServicePersonName =
        this.$refs.zfyzServeName.selectedLabel
      this.getPerson(this.addForm.serviceStation)
      // this.addForm.projectType = this.addForm.projectType.split(",")

      this.$emit("governmentAssistance", this.addForm)
    },
  },
}
</script>

<style lang="less" scoped>
.gov-title {
  width: 98%;
  margin-left: 2%;
}
.gov-title1 {
  width: 100%;
  display: flex;
}
.gov-title2 {
  width: 50%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #c0c4cc;
}
.gov-title2 > div:first-child {
  width: 140px;
  height: 50px;
  line-height: 50px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}
.gov-title2 > div:nth-child(2) {
  height: 50px;
  line-height: 50px;
  margin: 0 20px;
}
.right-title-2 {
  border-top: 1px solid #c0c4cc;
}
.right-title-3 {
  border-right: 1px solid #c0c4cc;
}
.right-title-4 {
  /deep/.el-input__inner {
    border: none;
  }
}
.gov-title5 {
  width: 100%;
  display: flex;

  border-bottom: 1px solid #c0c4cc;
}
.gov-title5 > div:first-child {
  width: 140px;
  height: 80px;
  line-height: 80px;
  border-right: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  text-align: center;
  background-color: #eeeeee;
}
.gov-title5 > div:nth-child(2) {
  width: calc(100% - 140px);

  /deep/.el-textarea__inner {
    border: none;
    resize: none;
  }
}
.pages {
  margin-top: 20px;
}
.flexBox {
  flex: 1;
}
.selectBorder {
  width: 100%;
  /deep/.el-input__inner {
    border: none;
  }
}
.addTitle {
  border-bottom: 1px solid #eee;
  padding: 10px 0;
  display: flex;
  line-height: 40px;
  .titleName {
    flex: 1;
    color: #409eff;
    font-size: 15px;
  }
  .fontSize {
    font-weight: bold;
    color: #409eff;
    line-height: 40px;
    cursor: pointer;
  }
}
.infoServe {
  margin-top: 20px;
  .infoItem {
    display: flex;
    flex-wrap: wrap;
    .serveFlex {
      width: 25%;
      margin-bottom: 15px;
      .serveContent {
        padding: 0 15px;
        display: flex;
        // margin-bottom: 10px;
        .serveName {
          width: 90px;
          padding-right: 10px;
          text-align: right;
          color: #606266;
          font-size: 14px;
          line-height: 40px;
        }
        .serveSign {
          flex: 1;
        }
      }
    }
    .delIcon {
      cursor: pointer;
      font-size: 20px;
      position: relative;
      top: 10px;
    }
  }
}
.entityServe {
  margin-top: 20px;
  border-top: 1px solid rgba(167, 164, 164, 0.8);
}
.right-title-6 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #c0c4cc;
  border-left: 1px solid #c0c4cc;
  background-color: #eeeeee;
}

.rightTitle {
  width: 140px;
  // height: 100%;
  text-align: center;
  position: relative;
  p {
    position: absolute;
    width: 100%;
    left: 0;
    top: 47%;
  }
}
.rightBox {
  background: #fff;
  border-left: 1px solid #c0c4cc;
  flex: 1;
  padding: 10px;
  line-height: 30px;
}
</style>
